import React from 'react';

const PromptHelpNotice: React.FC = () => {
  return (
    <div className="prompt-picker-help mb-3">
      Role-specific prompts are prepared when you finish Step 1. Use the{' '}
      <strong>Role-Specific Prompts</strong> tab to pick from your personalized list.
    </div>
  );
};

export default PromptHelpNotice;
